import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { Animate, Card, Table, useNavigate, useView } from 'components/lib'
import React from 'react'
import { Link } from 'react-router-dom'

function Emails() {
    const navigate = useNavigate()
    const view = useView()

    const { data, isLoading, refetch } = useQuery({
        queryKey: ['all', 'email'],
        queryFn: () => axios.get('/api/email')
    })

    const handleDelete = (data) => {
        if (data.template === 'MAIN') {
            return view.notification.show('MAIN Template cannot be deleted, you can only Edit it', 'error')
        }

        view.modal.show({
            title: 'Delete Email',
            form: {},
            buttonText: 'Yes, delete',
            text: `Are you sure you want to delete "${data.template}" email?`,
            url: `/api/email/${data.id}`,
            method: 'DELETE',
            destructive: true,
        }, () => refetch());
    }

    return (
        <Animate>
            <Card loading={isLoading}>
                <div className="flex flex-col mb-6 gap-2">
                    <Link
                        to='/emails/create'
                        className='text-blue-400 underline'
                    >
                        Create Email
                    </Link>
                    <Link
                        to='/emails/send'
                        className='text-blue-400 underline'
                    >
                        Send Email To Users
                    </Link>
                </div>

                <Table
                    search
                    data={data?.data?.data}
                    loading={isLoading}
                    show={['template', 'subject', 'from', 'created_at']}
                    actions={{
                        edit: (data) => navigate(`/emails/${data.id}/edit`),
                        delete: handleDelete
                    }}
                />
            </Card>
        </Animate>
    )
}

export default Emails